import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { IonSpinner } from '@ionic/vue';
    

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
        loading: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: 'crescent',
        },
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.loading)
      ? (_openBlock(), _createBlock(_unref(IonSpinner), {
          key: 0,
          class: "d-block mx-auto",
          name: __props.name,
          color: "primary"
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ]))
}
}

})